// 1. 引入
import axios from "axios";
import myNotification from "./my-notification";
import { assistantApiMessage } from "./assistant-ui-message";
import qs from "qs";
import { axiosEnum, axiosHeadEnum } from "@/api/enum";
import { getToken, logout, getCompanyId, getRole } from "./auth";
import LackAccountDialog from "./register-lack-accout-dialog";

// 取消请求
// let pending = [];
// const CancelToken = axios.CancelToken;
// const removePending = (config) => {
//     for (let p in pending) {
//         if (pending[p].url === config.url + "&" + config.method) {
//             pending[p].cancel("request canceled");
//             pending.splice(p, 1);
//         }
//     }
// };

const assistantApiBase = () => axiosHeadEnum[process.env.VUE_APP_API_ENV];

function isAssistantApiRequest(cfg) {
    if (!cfg?.baseURL) {
        return false;
    }
    const a = String(cfg.baseURL).replace(/\/$/, "");
    const b = String(assistantApiBase() || "").replace(/\/$/, "");
    return a === b && b !== "";
}

/** 义乌助手接口（assistant.js 等与 axiosHeadEnum 一致的 baseURL）走居中可关闭 Message，其余保持 Notification */
function notifyRequestError(cfg, payload) {
    if (isAssistantApiRequest(cfg)) {
        assistantApiMessage(payload);
    } else {
        myNotification(payload);
    }
}

// 接口错误处理函数
const errorHandler = (response) => {
    const responseConfig = response.config;
    const responseCode = response.data.code;
    const { showErrorMessage = true } = responseConfig;
    // 处理类似船舶定位接口报错信息返回异常,如果没有报错信息，则前端自己处理报错
    const message = response.data.msg || response.data.message;
    if (message && message !== "success" && message !== "SUCCESS") {
        if (showErrorMessage && responseCode !== 409) {
            notifyRequestError(responseConfig, {
                type: "error",
                title: message,
                duration: 2500,
            });
        }
        const curToken = getToken();
        if (curToken) {
            setTimeout(() => {
                if (responseCode === 401 || responseCode === 403) {
                    // 接口返回401和403的时候自动登出
                    logout();
                }
            }, 500);
        }
        return Promise.reject(new Error(message || "Error"));
    }
    return response;
};

// 2. 配置信息
const BASE_URL = String(axiosEnum[process.env.VUE_APP_API_ENV] || "").replace(/\/$/, "");
const EXCEL_MODEL_URL = `${BASE_URL}/blno/downLoad/excel/`; // 下载Excel模板链接
const EXCEL = `${BASE_URL}/blno/downLoad/excel/`;
const config = {
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    baseURL: BASE_URL,
    // 请求超时时间
    timeout: 30000,
    // 每次请求携带cookie
    // withCredentials: true,
    // 自定义请求头
    // headers: { "Authorization": store.state.token },
};

// 3. 创建实例
const instance = axios.create(config);
// request拦截器
instance.interceptors.request.use(
    (config) => {
        // removePending(config);
        // config.cancelToken = new CancelToken((c) => {
        //     pending.push({ cancel: c, url: config.url + "&" + config.method });
        // });
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json;charset=utf-8";
        }
        if (getToken() || config.headers["Authorization"]) {
            config.headers.Authorization =
                config.headers["Authorization"] || getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        return config;
    },

    (error) => {
        Promise.reject(error);
    },
);
// respone拦截器

instance.interceptors.response.use(
    (response) => {
        // removePending(response.config);

        // 如果是 blob 响应，直接返回，不进行 JSON 解析
        if (
            response.config.responseType === "blob" ||
            response.data instanceof Blob
        ) {
            return response;
        }

        // 检查响应数据是否是有效的 JSON 对象
        // 如果 response.data 是字符串或不是对象，可能是二进制数据被错误解析
        if (
            typeof response.data !== "object" ||
            response.data === null ||
            response.data instanceof ArrayBuffer
        ) {
            // 可能是二进制数据，直接返回
            return response;
        }

        // 报关单文件导入：可能 code=200 但仍带 msg 提示异常；需要弹错，同时把完整响应交给业务继续处理
        const uploadFileMsg = response.data.msg || response.data.message;
        if (
            response?.config?.url?.includes("/customs-template/uploadFile") &&
            uploadFileMsg &&
            uploadFileMsg !== "success" &&
            uploadFileMsg !== "SUCCESS"
        ) {
            const { showErrorMessage = true } = response.config;
            const uploadFileCode = response.data.code;
            if (showErrorMessage && uploadFileCode !== 409) {
                notifyRequestError(response.config, {
                    type: "warning",
                    title: uploadFileMsg,
                    duration: 0
                });
            }
            return response;
        }

        const responseCode = response.data.code;
        const responseStatus = response.data.status;
        const responseData = response.data.data;
        const responseConfig = response.config;
        const { onlyJudgeCode, onlyJudgeStatus } = responseConfig;
        if (onlyJudgeCode) {
            // 只判断code等于200即为接口请求成功
            if (responseCode === 200) {
                return response;
            } else {
                return errorHandler(response);
            }
        }
        if (onlyJudgeStatus) {
            const st = response.data && response.data.status;
            if (st === 200 || st === true) {
                return response;
            }
            return errorHandler(response);
        }
        // 余额不足,并且不是校验免费余额
        else if (
            responseCode === 402 &&
            !response.request.responseURL.includes(
                "pay/account/user/verFreeBalanceEn",
            )
        ) {
            const isMobile =
                window.location.pathname.indexOf("wxtruckmap") !== -1;
            if (!isMobile) {
                LackAccountDialog.install();
            } else {
                notifyRequestError(response.config, {
                    type: "error",
                    title: response.data.message,
                    duration: 2500,
                });
            }
            return Promise.reject("余额不足");
        } else if (
            (responseCode && responseCode !== 200) ||
            (responseStatus !== undefined && !responseStatus) ||
            !responseData
        ) {
            // 需判断code等于200且data不为空
            return errorHandler(response);
        }
        return response;
    },
    async (error) => {
        console.log("拦截器error", error);
        let code = 0;

        try {
            code = error.response.status;
        } catch (e) {
            if (error.toString().indexOf("Error: timeout") !== -1) {
                notifyRequestError(error.config, {
                    type: "error",
                    title: "网络请求超时",
                    duration: 2500,
                });
                return Promise.reject(error);
            }
            if (error.toString().indexOf("Error: Network Error") !== -1) {
                notifyRequestError(error.config, {
                    type: "error",
                    title: "网络请求错误",
                    duration: 2500,
                });
                return Promise.reject(error);
            }
        }

        if (code === 404) {
            notifyRequestError(error.config, {
                type: "error",
                title: `服务器异常${code}`,
                duration: 2500,
            });
            return Promise.reject(error);
        }

        // 处理 blob 类型的错误响应
        let errorMsg;
        let responseCode;

        if (error.response && error.response.data instanceof Blob) {
            try {
                // 尝试将 blob 转换为文本
                const text = await error.response.data.text();
                // 尝试解析为 JSON
                const jsonData = JSON.parse(text);
                errorMsg = jsonData.message || jsonData.msg || text;
                responseCode = jsonData.code;
            } catch (parseError) {
                // 如果解析失败，使用默认错误信息
                errorMsg = `请求失败 (${code})`;
                responseCode = code;
            }
        } else {
            // 处理普通的 JSON 响应
            errorMsg =
                error?.response?.data?.message ||
                error?.response?.data?.msg ||
                error?.response?.data;
            responseCode = error?.response?.data?.code;
        }

        if (errorMsg !== undefined && error?.config?.showErrorMessage !== false) {
            notifyRequestError(error.config, {
                type: "warning",
                title: errorMsg,
                duration: 2500,
            });
        }

        return Promise.reject(error);
    },
);

/*
 * request方法（统一axios请求方法的格式）
 * url       请求URL
 * type      请求类型
 * data      参数
 * isForm    是否表单数据
 * isQs      是否为字符串类型
 */
export const request = async (
    url = "",
    type = "GET",
    data = {},
    otherOptions = {},
    isForm = false,
    isQs = false,
    isNeedFee = false,
) => {
    let result;
    type = type.toUpperCase();
    const requestOptions = {
        method: type,
        url,
        ...otherOptions,
        baseURL: otherOptions?.baseURL ?? BASE_URL,
    };
    if (isForm) {
        const form = new FormData();
        Object.keys(data).forEach((key) => {
            const value = data[key];
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    form.append(key, item);
                });
            } else {
                form.append(key, data[key]);
            }
        });
        data = form;
    }
    if (isQs) {
        data = qs.stringify(data);
    }
    if (!requestOptions.headers) {
        requestOptions.headers = {
            "Content-type": isForm
                ? "multipart/form-data"
                : isQs
                ? "application/x-www-form-urlencoded"
                : "application/json",
        };
    }
    // 如果需要费用
    if (isNeedFee) {
        data = { ...data, companyId: getCompanyId(), role: getRole() };
    }

    if (type === "GET") {
        requestOptions.params = data;
    } else {
        requestOptions.data = data;
    }
    await instance(requestOptions).then((res) => {
        result = res;
    });
    return result;
};

// 4. 导出
export default { instance, BASE_URL, EXCEL_MODEL_URL, EXCEL };
